import { AuthState } from '@okta/okta-auth-js';
import { Role } from '@/app/api/role/role.types';
import { SELECTED_ADVISOR } from '@/advisors/advisors.constsnts';
import { Advisor } from '@/app/api/advisors/advisors.types';

export const AUTH_KEY = 'authInfo';
export const ROLE_KEY = 'role';

export const toKebabCase = (str: string): string => {
	return str
		.replace(/([a-z])([A-Z])/g, '$1-$2')
		.replace(/[\s_]+/g, '-')
		.toLowerCase();
};

export const copyLink = (text: string) => {
	// eslint-disable-next-line @typescript-eslint/no-floating-promises
	navigator.clipboard.writeText(text);
};

export const getAuthInfo = () => JSON.parse(localStorage.getItem(AUTH_KEY) || '{}') as AuthState;
export const getUserRole = () => JSON.parse(localStorage.getItem(ROLE_KEY) || '{}') as Role;
export const getSelectedAdvisor = () =>
	JSON.parse(localStorage.getItem(SELECTED_ADVISOR) || '{}') as Advisor;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce<T extends (...args: any[]) => void>(
	func: T,
	delay: number = 300
): (...args: Parameters<T>) => void {
	let timeoutId: ReturnType<typeof setTimeout>;

	return (...args: Parameters<T>): void => {
		// Clear the previous timeout
		if (timeoutId) {
			clearTimeout(timeoutId);
		}

		// Set a new timeout
		timeoutId = setTimeout(() => {
			func(...args);
		}, delay);
	};
}

export const downloadFile = (data: string, fileName: string) => {
	const url = window.URL.createObjectURL(new Blob([data]));
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', fileName);
	link.click();
	setTimeout(() => window.URL.revokeObjectURL(url), 0);
};
